import { Observable } from 'rxjs';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { RoutingHistoryService } from '../../routing/services/routing-history.service';
import { LoggerHelperService } from '../services/logger-helper.service';
import { LOGS_URL } from '../constants/consts';
import { InitializerService } from '../../initializer/initializer.service';


@Injectable()
export class HttpServiceLogInterceptor implements HttpInterceptor {

    private isBrowser: boolean;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private routingHistoryService: RoutingHistoryService,
        private loggerHelperService: LoggerHelperService,
        private initializerService: InitializerService,
        @Inject(LOGS_URL) private logsUrl: string,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.isBrowser) {
            return next.handle(req);
        }
        let newReq: HttpRequest<any> = req.clone({
            setHeaders: {
                'SID': this.loggerHelperService.sessionId || '',
                'CID': !req.url.includes(this.logsUrl) ? (this.loggerHelperService.correlationId || '') : '',
                'URF': this.routingHistoryService.previousUrl || '',
                'CAV': this.initializerService.getClientContext()?.Version || ''
            }
        });

        return next.handle(newReq);
    }
}
